import React from 'react';
import PropTypes from 'prop-types';
import { StyledButton } from './styled';
import { convertArrayToObject } from '../../../utils/helpers/convertArrayToObject';

const buttonTypes = [
  'default',
  'edit',
  'white',
  'delete',
  'green',
  'kapitalBank',
  'link',
  'singin'
];

export const ButtonTypeMap = convertArrayToObject(buttonTypes);

export const Button = ({
  type = 'button',
  name = null,
  text = '',
  onClick,
  onKeyPress,
  loading = false,
  disabled = false,
  stat,
  cypress,
  isSmall = false,
  children = null,
  state = ButtonTypeMap.default,
  styles = {},
  hover
}) => (
  <StyledButton
    data-cy={cypress}
    data-stat={stat}
    disabled={disabled}
    isSmall={isSmall}
    state={state}
    type={type}
    name={name}
    onClick={onClick}
    onKeyPress={onKeyPress}
    styles={styles}
    hover={hover}
  >
    {loading ? (
      <span className="f-loader" />
    ) : (
      <span>
        {children}
        {text}
      </span>
    )}
  </StyledButton>
);

Button.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onKeyPress: PropTypes.func,
  stat: PropTypes.string,
  cypress: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.node]),
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  isSmall: PropTypes.bool,
  state: PropTypes.oneOf(buttonTypes),
  styles: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  hover: PropTypes.string
};
